const parseScopes = (value: string | undefined, fallback: string[]) =>
  (value ? value.split(/[\s,]+/) : fallback).map((scope) => scope.trim()).filter(Boolean);

export const API_BASE = import.meta.env.VITE_API_BASE || 'https://dev.oliveeb.com';

/** Client identity used by gateway-scoped APIs. */
export const CLIENT_APP = import.meta.env.VITE_CLIENT_APP || 'OLITASK_WEB_UI';
export const CLIENT_NAME = 'OMC';
export const API_KEY = 'fe4c97e9-1733-4f13-8ac9-c6e56ea0a98a';

/** Auth tokens are issued by identity-service; profiles live on profile-service. */
export const IDENTITY_SERVICE_BASE_URL = `${API_BASE}/identity-service`;
export const PROFILE_SERVICE_BASE_URL = `${API_BASE}/profile-service`;

/** Charge/fee API stage group used by this web app. */
export const CLIENT_STAGES = import.meta.env.VITE_CLIENT_STAGES || 'OLITASK_WEB_UI_ALL';

export const GOOGLE_CLIENT_ID =
  import.meta.env.VITE_GOOGLE_CLIENT_ID ||
  '683497561168-me2b46eo37em3637kj84hr7dvffjobbc.apps.googleusercontent.com';
export const GOOGLE_AUTH_SCOPES = parseScopes(import.meta.env.VITE_GOOGLE_AUTH_SCOPES, [
  'profile',
  'email',
]);
export const GOOGLE_AUTH_SCOPE = GOOGLE_AUTH_SCOPES.join(' ');

export const APPLE_CLIENT_ID = import.meta.env.VITE_APPLE_CLIENT_ID || 'com.oliveeb.olitaskapp.web';
export const APPLE_REDIRECT_URI =
  import.meta.env.VITE_APPLE_REDIRECT_URI || 'https://dev.olitask.com/signin';
export const APPLE_AUTH_SCOPE =
  import.meta.env.VITE_APPLE_AUTH_SCOPE || 'openid name email';

/** Slug used in help/feedback payloads. */
export const SOURCE_APP_SLUG = 'olitask-web-ui';
